import React from 'react'
import './bill.less'
import { setHeader } from '@/util/set-header'
import PendingPay from './pending-pay/pending-pay'
import CompletedPay from './completed-pay/completed-pay'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'
import { Tabs, Toast } from 'antd-mobile'

const mapStateToProps = (state: any) => {
  return {
    payment: state.payment,
  }
}
@(connect(mapStateToProps) as any)
@(withRouter as any)
class Bill extends React.Component<any, any> {
  tabs = [{ title: '待付款' }, { title: '已付款' }]
  isHidden = true
  tabsIndex = 0
  mainDiv!: any
  constructor(props: any) {
    super(props)
    let { match } = this.props
    this.mainDiv = React.createRef()
    this.state = {
      tabsIndex: Number(match.params.index),
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    this.leftClick=this.leftClick.bind(this)
    this.tabChange=this.tabChange.bind(this)
  }
  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.payment
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后再缴费哦~', 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
  }
  componentDidMount() {
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(
        this.mainDiv.current,
      ) as any).getBoundingClientRect().top
    this.setState({
      height,
    })
  }

  leftClick () {
    let { location,history } = this.props
    //返回
    if(location.state&&location.state.from==='payment-record'){
      history.push({pathname:`/payment/record`})
    }else{
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '缴费记录', leftClick: this.leftClick })
  }
  tabChange(tab: any, index: number){
    let { location,history } = this.props
    if(index===0){
      history.replace({pathname:`/payment/bill/0`},location.state)
    }else{
      history.replace({pathname:`/payment/bill/1`},location.state)
    }
  }

  render() {
    return (
      <div className="pay-bill">
        <Tabs
          tabs={this.tabs}
          initialPage={this.state.tabsIndex}
          swipeable={false}
          onChange={(tab: any, index: number)=>this.tabChange(tab,index)}
        >
          <div
            style={{
              height: this.state.height,
            }}
            ref={this.mainDiv}
            className="pending"
          >
            <PendingPay></PendingPay>
          </div>
          <div
            style={{
              height: this.state.height,
            }}
            ref={this.mainDiv}
          >
            <CompletedPay></CompletedPay>
          </div>
        </Tabs>
      </div>
    )
  }
}

export default Bill
